<template>
  <main id="vue-app">

    <div id="bg-holder">
      <div class="lazy" id="home-bg" :style="{'background-image': `url(${image})`}">
        <div id="home-bg-2"></div>
      </div>
      <img class="lazy" src="/images/sggfundo.svg" id="watermark" alt="watermark">
    </div>

    <header class="container-fluid d-flex">
      <div id="logo">
        <router-link :to="{name: 'entrada'}">
          <img alt="" src="/images/logo-Sgg.png">
        </router-link>
      </div>

      <div class="d-flex w-100" id="nav-container">
        <div class="ml-auto my-auto">
          <div id="nav-hamburger">
            <button @click="navOpen = !navOpen" class="navbar-toggler" type="button">
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
          <div :class="{'open': navOpen}" id="nav">
            <ul>
              <li>
                <router-link :to="{name: 'entrada'}">Entrada</router-link>
              </li>
              <li>
                <router-link :to="{name: 'novidades'}">Blog</router-link>
              </li>
              <li>
                <router-link :to="{name: 'calendario'}" id="link_calendario">
                  Calendário Fiscal
                </router-link>
              </li>
              <li>
                <router-link :to="{name: 'servicos'}">Serviços</router-link>
              </li>
              <li>
                <router-link :to="{name: 'quemSomos'}">Quem somos</router-link>
              </li>


              <!--li>
                  <router-link :to="{name: 'podcasts'}">Podcasts</router-link>
              </li-->
              <li>
                <router-link :to="{name: 'contacto'}">Contactos</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>

    <router-view id="content"></router-view>

    <footer class="container-fluid d-md-flex">
      <div class="text-center text-md-left">
        <p>Soares Gomes & Gomes
          <br>Contabilidade e Gestão, Lda</p>
        <p>Av. República 2208 8 drt rec trz,<br><span>4430-196 V N Gaia</span></p>
      </div>
      <div class="text-center ml-md-auto mt-md-auto mb-3 text-md-right">
        <span>Todos os direitos Reservados</span>
        <br><span><a href="https://duplanet.pt" rel="noopener"
                     target="_blank">Duplanet.pt Soluções Multimédia</a></span>
        <br><div class="mt-3"><a href="https://www.livroreclamacoes.pt/" rel="noopener"
                     target="_blank">Livro de Reclamações</a></div>
      </div>
    </footer>

  </main>
</template>

<script>
export default {
  name: "AppComponent",
  metaInfo: {
    title: 'Soares Gomes & Gomes',
    titleTemplate: 'Soares Gomes & Gomes | %s',
    meta: [
      {description: 'Contabilidade e Gestão Lda - Mafamude e Vilar do Paraíso - Contabilidade'},
      {keywords: 'contabilidade, gestao, mafamude, vilar do paraiso, contabilidade e gestao'},
      {author: 'Duplanet.pt - Soluções Multimédia'},
    ],
    link: [
      {rel: 'alternate', type: 'application/rss+xml', title: 'Podcast RSS feed', href: '/rss/feed/podcasts'}
    ],
    htmlAttrs: {
      lang: 'pt',
      amp: false
    }
  },
  data() {
    return {
      image: '',
      navOpen: false
    }
  },
  watch: {
    '$route': function () {
      this.navOpen = false;
    }
  }
}
</script>

<style lang="scss">

//Fonts Personalizadas
@font-face {
  font-family: 'Avenir';
  src: url('/fonts/AvenirLTStd-Roman.otf');
}

@font-face {
  font-family: 'HelveticaLight';
  src: url('/fonts/HelveticaLTStd-Light.otf');
}

@font-face {
  font-family: 'HelveticaRoman';
  src: url('/fonts/HelveticaLTStd-Roman.otf');
}

#vue-app {
  font-family: HelveticaRoman, serif !important;

  #subHeader {
    padding: 35px 35px 50px;
    color: #c8c8c8;
    text-transform: uppercase;
    font-family: HelveticaRoman, serif !important;
    font-weight: bold;

    > h1 {
      font-size: calc(5vw + 10px);
      clip-path: polygon(0% 50%, 100% 50%, 100% 0%, 0 0%);
      margin: 0 0 -2%;
      opacity: .25;
    }

    > h2 {
      font-size: calc(1.3vw + 5px);
      opacity: .8;
      margin: 0;
    }
  }

  ul.pagination {
    .page-link {
      color: #000;
      background-color: rgba(151, 169, 162, 1);
      border-color: rgba(0, 0, 0, 0.6);
    }

    .page-item.active .page-link {
      color: #97A9A2;
      background-color: rgba(0, 0, 0, 1);
      border-color: rgba(0, 0, 0, 0.6);
    }
  }
}

#nprogress .bar {
  background: #97A9A2 !important;
}

#nprogress .spinner {
  top: unset !important;
  bottom: 15px !important;
  left: 15px !important;
}

#nprogress .spinner-icon {
  width: 35px !important;
  height: 35px !important;
  border-top-color: #97A9A2 !important;
  border-left-color: #798b84 !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #000000;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #97A9A2;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #64716c;
}


</style>

<style lang="scss" scoped>
main {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
}

#logo {
  flex-grow: 0 !important;

  > a > img {
    height: 65px;
    width: auto;
    object-fit: contain;
  }

}

body {
  color: #c8c8c8;
}

header {
  padding: 35px !important;
  height: auto;
  z-index: 2;

  .navbar-toggler-icon {
    background-image: url('/images/hamburger6.svg');
  }

}

#content {
  flex: 1;
  z-index: 2;
  color: #c8c8c8;
  font-size: 1.3em;
}

#nav {

  > ul {
    margin: 0;
    transition: all .5s ease;
  }

  > ul > li > a {
    text-decoration: none;
    color: #bababa;
    display: block;
    &:hover {
      color: #fff;
    }
  }

  > ul > li {
    list-style: none;
    display: inline-block;
    padding: 5px;
    text-transform: uppercase;
    font-family: HelveticaLight, serif !important;
  }

  > ul > li > a.router-link-exact-active {
    font-weight: bold;

    &:first-letter {
      font-size: 1.3rem;
    }
  }

  /*#link_calendario {
      color: yellow;
  }*/

}

#bg-holder {

  position: fixed;
  z-index: 0;
  top: 0;
  width: 100%;
  height: 100%;

  #home-bg {
    height: 100%;
    background-color: #000;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transition: all .5s ease-in-out;
  }

  #home-bg-2 {
    background-color: rgba(18, 24, 27, .7);
    height: 100%;
  }

}

#watermark {
  position: fixed;
  bottom: 0;
  right: 0;
  opacity: 0.05;
  width: 50vw;
  height: 35vh;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
  pointer-events: none;
  z-index: 2;
}

footer {
  position: relative;
  z-index: 5;
  margin-top: 35px;
  font-size: .8em;

  * {
    color: #c8c8c8;
    font-family: HelveticaLight, serif !important;
  }

  a, a:hover {
    text-decoration: none;
    color: #fff;
    cursor: pointer;
  }

}

@media screen and (min-width: 921px) {
  header #nav-hamburger {
    display: none;
  }
}

@media screen and (max-width: 920px) {

  #nav-container {
    flex-direction: column;
  }

  header {
    position: relative;
    z-index: 999;
  }

  #nav {
    min-width: 100vw;
    background-color: rgba(0, 0, 0, .95);
    border-radius: 5px;
    margin-top: 35px;
    padding: 5vh 5vw;
    margin-left: -20px;
    overflow: hidden;
    transition: all .5s ease;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 999;

    &:not(.open) {
      height: 0;
      padding: 0;
    }

    > ul {
      float: left;

      > li {
        display: block;

        > a {
          width: 100%;
          display: block;
          padding: 5px;
        }
      }
    }

  }
}
</style>